import {
  DownloadOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
  InfoCircleOutlined,
  EyeOutlined
} from "@ant-design/icons";
import {
  Card,
  Form,
  Select,
  Modal,
  Popover,
  InputNumber,
  Input,
  DatePicker,
  Divider,
  Space,
  Button,
  message,
  Upload,
  Popconfirm,
  Table
} from "antd";
import { useEffect, useState } from "react";
import {
  ADD_B2BLC_REMARKS,
  ADD_LC_REASON,
  B2BLC_DOCUMENT_UPLOAD,
  B2BLC_REMARKS_LIST,
  EXPORT_LC_REASONS,
  SALES_CONTRACT_COMMERCIAL_DOC,
} from "../../../../apiServices/API_ENDPOINTS";
import { useParams } from "react-router";
import { getData, postData } from "../../../../apiServices/common";
import HandleNotification from "../../../../common/Notification";
import { isArrayAndHasValue } from "../../../../utils/functions";
import { BASE_URL } from "../../../../apiServices";

const token = localStorage.getItem("token");

const ChallanAssignTable = (props) => {
  // Props
  const { 
    challanDetailsList, 
    setChallanDetailsList, 
    challanList, 
    invoiceDetails,
    diffDetails,
    setDiffDetails,
    isEdit,
    viewMode
  } = props;

  // Antd
  const [challanForm] = Form.useForm();

  // Modal states for showing category details
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedChallanCategories, setSelectedChallanCategories] = useState([]);
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const [highlightedRowId, setHighlightedRowId] = useState(null);
  

  // Others
  const { reconciliationId } = useParams();

  const removeRow = (challan_id_to_remove) => {
    // Filter out rows with the given challan_id
    const filteredList = challanDetailsList.filter(
      (item) => item.challan_id !== challan_id_to_remove
    );
  
    // Reassign unique_id for remaining items
    const rearrangedList = filteredList.map((item, index) => ({
      ...item,
      unique_id: index + 1,
    }));
  
    setChallanDetailsList(rearrangedList);
  };

  const handleShowCategories = (challan) => {
    setSelectedChallanCategories(challan.categories || []);
    setSelectedChallanNo(challan.challan_no);
    setModalVisible(true);
    setHighlightedRowId(challan.challan_id);
  };
  

  const handleChangeChallan = (selectedOption, index) => {
    const selectedChallan = challanList?.find((challan) => challan?.id === selectedOption);
  
    if (selectedChallan) {
      const details = selectedChallan?.details || [];
      const updatedChallanDetailsList = [...challanDetailsList];
      
      // Update the selected row with the details of the selected challan
      updatedChallanDetailsList[index] = {
        ...updatedChallanDetailsList[index],
        challan_id: selectedChallan?.id,
        received_date: "",
        item_category: "",
        challan_qty: "",
        unit: "",
        challan_value: "",
      };
  
      // Remove any existing rows related to the same challan
      const filteredDetails = updatedChallanDetailsList?.filter((item) => item?.challan_id !== selectedChallan?.id);
  
      // Add new rows for each detail
      details?.forEach((detail, detailIndex) => {
        const newDetailRow = {
          unique_id: updatedChallanDetailsList?.length + 1 + detailIndex,
          challan_id: selectedChallan?.id,
          received_date: detail?.received_date,
          item_category: detail?.item_category,
          challan_qty: detail?.challan_qty,
          unit: detail?.unit,
          challan_value: detail?.challan_value,
        };
  
        filteredDetails.push(newDetailRow);
      });
  
      setChallanDetailsList(filteredDetails);
    }
  };

  const calculateDifferences = () => {
    let totalChallanQty, totalChallanValue;

    if(challanDetailsList[0]?.challan_id) {
      totalChallanValue = challanDetailsList?.reduce(function(prev, current) {
        return prev + +current?.challan_value
      }, 0);

      totalChallanQty = challanDetailsList?.reduce(function(prev, current) {
        return prev + +current?.challan_qty
      }, 0);

      if(invoiceDetails) {
        let status;
        if(invoiceDetails?.invoice_qty != totalChallanQty && invoiceDetails?.invoice_value != totalChallanValue) {
          status = 'Gap';
        } else if(invoiceDetails?.invoice_qty == totalChallanQty && invoiceDetails?.invoice_value == totalChallanValue) {
          status = 'Done';
        } else {
          status = 'Pending';
        }

        setDiffDetails({
          diffQty: invoiceDetails?.quantity_ctn - totalChallanQty,
          diffValue: invoiceDetails?.invoice_value - totalChallanValue,
          totalChallanValue: totalChallanValue,
          status: status
        })
      }
    }

    if(challanDetailsList?.length === 0) {
      setDiffDetails(null)
    }
  };
    
  useEffect(() => {
    calculateDifferences();
  }, [challanDetailsList]);

  const modalColumns = [
    {
      title: "Item Category",
      dataIndex: "item_category",
      key: "item_category",
      align: "center",
    },
    {
      title: "Received Date",
      dataIndex: "received_date",
      key: "received_date",
      render: (date) => date,
      align: "center",
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "Quantity",
      dataIndex: "challan_qty",
      key: "challan_qty",
      align: "right",
    },
    // {
    //   title: "Value",
    //   dataIndex: "challan_value",
    //   key: "challan_value",
    // },
  ];

  

  return (
    <>
    <Form form={challanForm}>
      <div>
        <Card
          title={<span style={{ fontSize: "14px" }}>Reconciled Challans</span>}
        >
          <div className="custome-table">
            <table style={{width: "900px"}}>
              <thead>
                {/* <tr>
                  <th className="t-header" colSpan="2"> </th>
                  <th className="t-header bc-java " colSpan="2">
                    Change
                  </th>
                </tr> */}
                <tr>
                  <th key="challan_id" className="bc-java ">
                    challan No{" "}
                  </th>
                  <th key="challan_qty" className="bc-java " style={{ textAlign: "right" }}>
                    Challan Qty{" "}
                  </th>
                  {/* <th key="challan_value" className="bc-java ">
                    Challan Value{" "}
                  </th> */}
                  <th key="status" className="bc-java ">
                    Status{" "}
                  </th>
                  <th key="header_remove" className="bc-java " style={{ width: "80px"}}>
                    Info{" "}
                  </th>
                  {/* {!viewMode && (
                    <th key="header_remove" className="bc-java " style={{ width: "80px"}}>
                      Actions{" "}
                    </th>
                  )} */}
                </tr>
              </thead>

              <tbody className="scrollable-table-container">
                {isArrayAndHasValue(challanDetailsList) &&
                  challanDetailsList?.map((item, index) => {
                    return (
                      <tr key={`table_parent_key_${index}`}
                        style={
                          highlightedRowId === item.challan_id
                            ? { backgroundColor: "#beb2bb", transition: "background-color 0.3s ease" }
                            : {}
                        }
                      >
                        <td className="t-body">
                          <Form.Item
                            style={{ marginBottom: "unset !important" }}
                          >
                            <Select
                              showSearch
                              placeholder="Challan"
                              style={{ width: "100%" }}
                              value={item?.challan_id}
                              disabled={true}
                              // disabled={isEdit ? true:false}
                              onChange={(value) => handleChangeChallan(value, index)}
                            >
                              {isArrayAndHasValue(challanDetailsList) &&
                                challanDetailsList?.map((option) => {
                                  return (
                                    <option key={option.challan_id} value={option.challan_id}>
                                      {option.challan_no}
                                    </option>
                                  );
                              })}
                            </Select>
                          </Form.Item>
                        </td>
                        <td className="t-body">
                          <Form.Item style={{ marginBottom: "unset !important" }} >
                          <Input
                            name={`challan_qty_${index}`}
                            value={item.challan_qty}
                            size="small"
                            align="center"
                            placeholder="Challan Qty"
                            disabled={true}
                            style={{ textAlign: "right" }}
                          />
                          </Form.Item>
                        </td>
                        {/* <td className="t-body">
                          <Form.Item style={{ marginBottom: "unset !important" }} >
                            <Input
                              name={`challan_value_${index}`}
                              value={item.challan_value.toFixed(2)}
                              size="small"
                              placeholder="Challan value"
                              disabled={true}
                              style={{ textAlign: "right" }}
                            />
                          </Form.Item>
                        </td> */}
                        <td className="t-body">
                          <Form.Item style={{ marginBottom: "unset !important" }} >
                          <Input
                            name={`status_${index}`}
                            value={item.status}
                            size="small"
                            align="center"
                            placeholder="Status"
                            disabled={true}
                            style={{ textAlign: "center" }}
                          />
                          </Form.Item>
                        </td>
                        <td className="t-body" style={{ textAlign: "center" }}>
                          {/* Info icon to view category details */}
                          <EyeOutlined
                            style={{
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleShowCategories(item)}
                          />
                        </td>
                        {/* {!viewMode && (
                        <td className="t-body" style={{ textAlign: "center" }}>
                          <Popconfirm
                            title={
                              <>
                                <div>Are you sure?</div>
                                <div
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: "12px",
                                    marginTop: "4px",
                                  }}
                                >
                                  All related items with this Challan will be
                                  removed.
                                </div>
                              </>
                            }
                            onConfirm={() => removeRow(item.challan_id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <MinusCircleOutlined
                              style={{
                                fontSize: "16px",
                                color: "red",
                                cursor: "pointer",
                              }}
                            />
                          </Popconfirm>
                        </td>
                        )} */}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </Form>
    {/* Modal to show category breakdown */}
    <Modal
      title={
        <span>
          Category Details for Challan No:{" "}
          <span style={{ color: "red", fontWeight: "bold" }}>{selectedChallanNo}</span>
        </span>
      }
      visible={modalVisible}
      footer={null}
      onCancel={() => {
        setModalVisible(false);
        setHighlightedRowId(null);
      }}
      width={700}
    >
      {isArrayAndHasValue(selectedChallanCategories) ? (
        <Table
        bordered
          dataSource={selectedChallanCategories.map((cat, idx) => ({
            ...cat,
            key: idx,
          }))}
          columns={modalColumns}
          pagination={false}
        />
      ) : (
        <p>No category details available.</p>
      )}
    </Modal>
    </>
  );
};

export default ChallanAssignTable;
